import { Observable } from 'rxjs';
export function neverComplete() {
    return (source$) => new Observable((observer) => source$.subscribe({
        next: (value) => observer.next(value),
        error: (error) => observer.error(error),
        complete: () => {
        },
    }));
}

//# sourceMappingURL=neverComplete.js.map
